<template>
  <div id="root">
     <vs-table v-if="isMounted" ref="table" stripe description description-title="Angezeigt" description-connector="von"
      description-body="Einträgen" pagination :max-items="itemsPerPage" search :data="contactForms">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h3>
            Diese Kunden haben Fragen
        </h3>
      </div>

      <template slot="thead">
        <vs-th sort-key="date">Datum</vs-th>
        <vs-th sort-key="email">E-Mail</vs-th>
        <vs-th sort-key="phone">Telefon</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th>Lesen</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.date | moment("DD.MM.YYYY HH:mm")}}</p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ tr.email}}</p>
              </vs-td>

                <vs-td>
                <p class="product-category">{{ tr.phone}}</p>
              </vs-td>

               <vs-td>
                <p class="product-category">{{ tr.name}}</p>
              </vs-td>
       
              <vs-td class="whitespace-no-wrap">

                <feather-icon class="mr-4" :id="'details-' + tr._id" icon="InfoIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="showDetails(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>


<!-- POPUP TO SHOW DETAILED DATA-->
<vs-popup v-if="selectedItem" class="holamundo" title="Nachricht von Kunden" :active.sync="popupActive">
    <div id="popup">
   <p>{{selectedItem.message}}</p>
    </div>
    </vs-popup>

    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    data() {
    return {
      itemsPerPage: 10,
      isMounted: false,
      popupActive: false,
      selectedItem: null
    }
},
    computed : {
     contactForms() {
        return this.$store.state.contactForm.contactForms || [];
    },
},
created() {
    this.getContactForms();
},
mounted() {
    this.isMounted = true
},
    methods: {
   ...mapActions({
      getContactForms: "contactForm/getContactForms",
    }),
     showDetails(item) {
        this.selectedItem = item,
        this.popupActive = true
    } 
}

}
</script>




<style>

</style>